/**
 * HC pack picker: servings/savings/per-day UI + keeps add-to-cart in sync with selected pack.
 */
(function () {
  const VARIANT_UPDATE = 'variant:update';

  const PER_DAY_COPY = {
    1: 'Just Rs.21/day',
    3: 'Just Rs.14/day',
    6: 'Just Rs.12/day',
  };

  function formatSaving(moneyFormatted) {
    return 'SAVING ' + moneyFormatted + '/Bottle';
  }

  function getPackMonthsFromInput(input) {
    const wrap = input?.closest('.hc-variant-card-wrap');
    if (!wrap?.dataset.servings) return null;
    const months = Math.round(Number(wrap.dataset.servings) / 30);
    return months > 0 ? months : null;
  }

  function getCheckedPackInput(section) {
    const picker = section.querySelector('variant-picker');
    if (!picker) return null;
    return picker.querySelector('.hc-variant-card-wrap input[type="radio"][data-variant-id]:checked');
  }

  function getProductForm(section) {
    return section.querySelector('product-form-component');
  }

  function applyPickerVariantToForm(section) {
    if (!section) return;

    const checked = getCheckedPackInput(section);
    if (!(checked instanceof HTMLInputElement)) return;

    const variantId = checked.dataset.variantId;
    if (!variantId) return;

    const form = getProductForm(section);
    if (!form) return;

    const variantInput = form.querySelector('input[name="id"]');
    if (variantInput instanceof HTMLInputElement) {
      variantInput.value = variantId;
      variantInput.dispatchEvent(new Event('change', { bubbles: true }));
    }

    const addToCartComponent = form.querySelector('add-to-cart-component');
    const button = form.querySelector('[ref="addToCartButton"]');
    const label = button?.querySelector('.add-to-cart-text__content span span');
    const translation = window.Theme?.translations?.add_to_cart;
    const addToCartLabel =
      typeof translation === 'string' && translation.trim().length > 0
        ? translation.trim()
        : 'Add to cart';

    addToCartComponent?.enable?.();
    if (button instanceof HTMLButtonElement) {
      button.disabled = false;
      button.removeAttribute('disabled');
    }
    if (label && button.dataset.hcAtcMode !== 'checkout') {
      label.textContent = addToCartLabel;
    }
  }

  function getCardPriceValues(wrap) {
    if (!wrap) return null;

    const cardPriceEl = wrap.querySelector('.hc-variant-card__price');
    if (!cardPriceEl) return null;

    const cardCompareEl = wrap.querySelector('.hc-variant-card__compare');
    const cardCompare = cardCompareEl?.textContent.trim() || '';

    return {
      price: cardPriceEl.textContent.trim(),
      compare: cardCompare,
      showCompare: cardCompare.length > 0,
    };
  }

  function syncPriceContainer(container, priceValues) {
    if (!container || !priceValues) return;

    const { price, compare, showCompare } = priceValues;
    const regularBlock = container.querySelector('.price__regular');
    const saleBlock = container.querySelector('.price__sale');

    if (saleBlock) {
      const salePriceEl = saleBlock.querySelector('.price-item--sale.price');
      const compareAtEl = saleBlock.querySelector('.compare-at-price');

      if (showCompare) {
        if (salePriceEl) salePriceEl.textContent = price;
        if (compareAtEl) compareAtEl.textContent = compare;
        saleBlock.classList.remove('price__hidden');
        regularBlock?.classList.add('price__hidden');
      } else {
        saleBlock.classList.add('price__hidden');
        regularBlock?.classList.remove('price__hidden');
        const regularPrice = regularBlock?.querySelector('.price');
        if (regularPrice) regularPrice.textContent = price;
      }
    } else {
      const priceEl = container.querySelector('.price');
      if (priceEl) priceEl.textContent = price;
    }
  }

  function syncMainPrice(section, selectedInput) {
    const wrap = selectedInput?.closest('.hc-variant-card-wrap');
    const priceValues = getCardPriceValues(wrap);
    const container = section.querySelector('product-price [ref="priceContainer"]');
    syncPriceContainer(container, priceValues);
  }

  function syncStickyAtc(section, selectedInput) {
    const shopifySection = section.closest('.shopify-section');
    const sticky = shopifySection?.querySelector('sticky-add-to-cart');
    if (!sticky || !(selectedInput instanceof HTMLInputElement)) return;

    const wrap = selectedInput.closest('.hc-variant-card-wrap');
    const priceValues = getCardPriceValues(wrap);

    const variantTitleEl = sticky.querySelector('.sticky-add-to-cart__variant');
    const cardTitle = wrap?.querySelector('.hc-variant-card__title');
    if (variantTitleEl && cardTitle) {
      variantTitleEl.textContent = cardTitle.textContent.trim();
      variantTitleEl.style.removeProperty('display');
    }

    if (selectedInput.dataset.variantId) {
      sticky.dataset.currentVariantId = selectedInput.dataset.variantId;
    }

    const stickyContainer = sticky.querySelector('.sticky-add-to-cart__price [ref="priceContainer"]');
    syncPriceContainer(stickyContainer, priceValues);
  }

  function syncPerDayPrice(section, selectedInput) {
    const perDayEl = section.querySelector('#hc-per-day-price');
    if (!perDayEl) return;

    const pill =
      perDayEl.querySelector('.hc-per-day-pill') instanceof HTMLElement
        ? perDayEl.querySelector('.hc-per-day-pill')
        : perDayEl;

    const months = getPackMonthsFromInput(selectedInput);
    const copy = months && PER_DAY_COPY[months];
    if (copy && pill instanceof HTMLElement) {
      pill.textContent = copy;
      perDayEl.removeAttribute('hidden');
    } else {
      if (pill instanceof HTMLElement) {
        pill.textContent = '';
      }
      perDayEl.setAttribute('hidden', '');
    }
  }

  function syncPackMeta(variantPicker, selectedInput) {
    const wrap = selectedInput?.closest('.hc-variant-card-wrap');
    if (!wrap?.dataset.servings) return;

    const servingsEl = variantPicker.querySelector('#servings-text');
    if (servingsEl) {
      servingsEl.textContent = wrap.dataset.servings + ' servings total';
    }

    const savingAmount = wrap.dataset.saving;
    const newSavingEl = wrap.querySelector('.hc-variant-card__saving');
    const prevSavingEl = variantPicker.querySelector('#saving-text');

    if (prevSavingEl && prevSavingEl !== newSavingEl) {
      prevSavingEl.removeAttribute('id');
    }

    if (newSavingEl && savingAmount) {
      newSavingEl.id = 'saving-text';
      newSavingEl.textContent = formatSaving(savingAmount);
    }

    syncDiscountPill(wrap);
  }

  function syncDiscountPill(wrap) {
    const pill = document.querySelector('.product-information product-price #hc-price-discount-pill');
    if (!pill) return;

    const pct = wrap?.dataset.discountPct;
    if (pct) {
      pill.textContent = pct + '% OFF';
      pill.removeAttribute('hidden');
    } else {
      pill.textContent = '';
      pill.setAttribute('hidden', '');
    }
  }

  function syncSection(section) {
    if (!section?.classList?.contains('product-information')) return;

    const picker = section.querySelector('variant-picker');
    const checked = getCheckedPackInput(section);
    if (picker && checked instanceof HTMLInputElement) {
      syncPackMeta(picker, checked);
      syncMainPrice(section, checked);
      syncStickyAtc(section, checked);
      syncPerDayPrice(section, checked);
    }

    applyPickerVariantToForm(section);
  }

  function scheduleSectionSync(section) {
    syncSection(section);
    requestAnimationFrame(() => syncSection(section));
    setTimeout(() => syncSection(section), 0);
    setTimeout(() => syncSection(section), 50);
  }

  function syncAll() {
    document.querySelectorAll('.product-information').forEach((section) => {
      syncSection(section);
    });
  }

  document.addEventListener(
    'change',
    (e) => {
      const t = e.target;
      if (!(t instanceof HTMLInputElement) || t.type !== 'radio') return;
      if (!t.closest('.hc-variant-card-wrap')) return;
      const section = t.closest('.product-information');
      if (section instanceof HTMLElement) {
        scheduleSectionSync(section);
      }
    },
    false
  );

  document.addEventListener(
    VARIANT_UPDATE,
    (e) => {
      const target = e.target;
      if (!(target instanceof HTMLElement)) return;
      const section = target.closest('.product-information');
      if (section instanceof HTMLElement) {
        scheduleSectionSync(section);
      }
    },
    false
  );

  function scheduleSync() {
    syncAll();
    requestAnimationFrame(syncAll);
    setTimeout(syncAll, 0);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', scheduleSync, { once: true });
  } else {
    scheduleSync();
  }

  document.addEventListener('shopify:section:load', (event) => {
    if (event.target instanceof HTMLElement) {
      syncAll();
      requestAnimationFrame(syncAll);
    }
  });
})();
